import React from 'react';
import { CheckIcon } from 'lucide-react';
import { volumes } from '../../data/content';
import { CTAButton } from '../CTAButton';
export function WhatsInside() {
  return <section className="bg-cream py-14 sm:py-20" data-id="element-282" data-mp="1ljlcbxhmtp90">
      <div className="mx-auto w-full max-w-3xl px-4" data-id="element-283" data-mp="1lia8xys3mjif">
        <h2 className="text-center font-display text-[27px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-284" data-mp="1gki9mjp4jv47">
          What’s inside Mechanics Decision Map™
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15.5px] leading-relaxed text-navy-800/75 sm:text-lg" data-id="element-285" data-mp="1cgtwllhq47bk">
          Six premium volumes that take you from clinical objective to controlled mechanics.
        </p>

        <div className="mt-9 space-y-4" data-id="element-286" data-mp="xlnsx563okle">
          {volumes.map(volume => <article key={volume.number} className="rounded-2xl bg-white p-5 ring-1 ring-navy-900/10 sm:p-7" data-id="element-287" data-mp="xnqnm2i771wg">
              <span className="inline-block rounded-md bg-navy-900 px-2.5 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.14em] text-sky-400" data-id="element-288" data-mp="2s0qcyncdragx">
                {volume.number}
              </span>
              <h3 className="mt-3 font-display text-[21px] font-bold leading-tight text-navy-900 sm:text-2xl" data-id="element-289" data-mp="1poswfqbwcb1f">
                {volume.title}
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed text-navy-800/80" data-id="element-290" data-mp="1fplj3355wgeb">{volume.intro}</p>

              {volume.highlight ? <p className="mt-4 break-words rounded-xl bg-sand px-4 py-3 text-[12.5px] font-extrabold uppercase leading-relaxed tracking-[0.04em] text-navy-900 sm:text-sm" data-id="element-291" data-mp="23g7k4agr10et">
                  {volume.highlight}
                </p> : null}

              {volume.bullets ? <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-292" data-mp="1yno83hxpmdc4">
                  {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2" data-id="element-293" data-mp="2md8s845lngmz">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-600" aria-hidden="true" data-id="element-294" data-mp="2r50hmbd0rgbj" />
                      <span className="text-[14.5px] leading-snug text-navy-800/85" data-id="element-295" data-mp="310zc512rbsnr">{bullet}</span>
                    </li>)}
                </ul> : null}

              {volume.closing ? <p className="mt-4 text-[15px] leading-relaxed text-navy-800/80" data-id="element-296" data-mp="2ryhnkfzmqnxl">{volume.closing}</p> : null}
            </article>)}
        </div>

        <div className="mx-auto mt-9 max-w-xl" data-id="element-297" data-mp="2i24vtnnnak5h">
          <CTAButton label="Yes — I want access to the complete system" data-id="element-298" data-mp="2i3y3n69zvaf2" />
        </div>
      </div>
    </section>;
}